import { SettingLandingBannersHistoryInformationContainer } from "..";

export const SettingLandingBannersHistoryMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingBannersHistoryInformationContainer />
    </div>
  );
};
